export default class Role {
  constructor(role) {
    Object.assign(this, role);
    this.id = `${role.id}`;
  }
}
